import React, { FC } from 'react';

import { FillCircle, OuterCircle } from '../styles';

interface RadioProps {
  name: string;
  label: string;
  value?: boolean;
  error?: boolean;
  selected?: boolean;
  onValueSelected: (selected: boolean) => void;
}

export const Radio: FC<RadioProps> = ({
  name,
  label,
  value,
  error,
  selected,
  onValueSelected,
}) => (
  <OuterCircle
    id={`${name}-radio-button`}
    data-testid={`${name}-radio-button`}
    error={error}
    selected={selected}
    role="option"
    type="button"
    aria-label={label}
    aria-controls={label}
    aria-selected={selected}
    onClick={() => onValueSelected(value)}
  >
    <FillCircle
      id={`${name}-radio-fill`}
      data-testid={`${name}-radio-fill`}
      selected={selected}
    />
  </OuterCircle>
);

Radio.defaultProps = {
  value: undefined,
  selected: undefined,
  error: undefined,
};
